import { Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

const MESSAGE_SX = {
  m: 0,
  mt: 1,
  maxHeight: 80,
  overflowX: 'hidden',
  overflowY: 'auto',
  whiteSpace: 'pre-wrap',
  borderRadius: 2,
  backgroundColor: 'var(--mui-palette-background-paper)',
  px: 1.5,
  py: 1,
  overflowWrap: 'break-word',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
} as const;

const InterruptionMessageText = ({ children }: PropsWithChildren) => (
  <Typography component="p" variant="body1" color="textPrimary" sx={MESSAGE_SX}>
    {children}
  </Typography>
);

export default InterruptionMessageText;
